import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Barcode, Camera, Smartphone } from 'lucide-react';
import BarcodeScannerModal from '../../components/BarcodeScannerModal';
import { STOCK_PANEL } from './stockV2Ui';
import { classifyArticleHeuristic, isPhoneLikeArticle } from './stockProductClassify';

export { classifyArticleHeuristic, isPhoneLikeArticle };

const StockImeiTraceSection = ({
  imei,
  onImeiChange,
  reference,
  magasinId = 'M1',
  compact = false,
  showLink = true,
  required = false,
}) => (
  <div className={`${STOCK_PANEL} p-4 ${compact ? '' : 'sm:p-5'}`} data-testid="stock-imei-trace-section">
    <div className="flex items-start gap-3 mb-4">
      <Smartphone className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
      <div>
        <h3 className="text-sm font-bold text-white">
          Traçabilité IMEI / N° série
          {required && <span className="text-red-400 font-normal ml-1">*</span>}
        </h3>
        <p className="text-xs text-gray-500 mt-1">
          {required ? 'Obligatoire' : 'Recommandé'} pour chaque téléphone en stock — vente, réparation et historique.
          {magasinId && <span className="text-gray-400"> Magasin : <strong className="text-gray-300">{magasinId}</strong></span>}
        </p>
      </div>
    </div>
    <ImeiInputRow imei={imei} onImeiChange={onImeiChange} reference={reference} />
    {showLink && reference && (
      <p className="text-[11px] text-gray-600 mt-3">
        Plusieurs appareils ?{' '}
        <Link to={`/admin/stock-avance?tab=imei&ref=${encodeURIComponent(reference)}&open=1`} className="text-red-400 hover:text-red-300">
          Enregistrer les IMEI dans Stock avancé →
        </Link>
      </p>
    )}
  </div>
);

export const ImeiInputRow = ({ imei, onImeiChange, reference }) => {
  const [showScanner, setShowScanner] = useState(false);
  return (
    <>
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={() => setShowScanner(true)} className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-white/10 bg-black/20 text-gray-300 hover:text-white text-sm font-semibold min-h-[44px]" data-testid="imei-scan-btn">
          <Camera className="w-4 h-4" /> Scanner IMEI
        </button>
        <div className="relative flex-1 min-w-[200px]">
          <input
            type="text"
            value={imei}
            onChange={(e) => onImeiChange(e.target.value.replace(/\s/g, ''))}
            className="input-dark w-full py-2.5 pl-10 font-mono text-sm"
            placeholder="353012345678901"
            maxLength={20}
            data-testid="imei-input"
          />
          <Barcode className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
        </div>
      </div>
      {reference && imei && (
        <p className="text-xs text-emerald-400/90 mt-2">Sera lié à la réf. <span className="font-mono">{reference}</span> à l&apos;enregistrement.</p>
      )}
      <BarcodeScannerModal isOpen={showScanner} onClose={() => setShowScanner(false)} onScan={(code) => onImeiChange(String(code).replace(/\D/g, '').slice(0, 20))} />
    </>
  );
};

export default StockImeiTraceSection;
